// How the causes of a middlegame gone wrong are named, explained, ordered and
// coloured, for the "How you lost ground" pie and anything else that shows
// them. The colours are the losses' red band (`@chess/api-ending-case/colors.css`,
// the ending's Slipped · Missed · Lost on time · Lost), deepest first.
import { GROUND_CAUSES, type GroundCause } from '@chess/api-model';

export interface GroundCauseView {
  cause: GroundCause;
  label: string;
  /** One sentence for a tooltip. */
  description: string;
  /** A CSS colour (a token of the losses' red band). */
  colour: string;
}

const VIEW: Record<GroundCause, Omit<GroundCauseView, 'cause'>> = {
  tactic: { label: 'Tactic', description: 'Most of it went in tactics: allowed mate, a piece left hanging, a fork walked into', colour: 'var(--viz-ending-slipped)' },
  missed: { label: 'Missed chance', description: 'Most of it went in winning moves not played', colour: 'var(--viz-ending-missed)' },
  time: { label: 'Time', description: 'Most of it went in moves made with under a minute on the clock', colour: 'var(--viz-ending-time)' },
  positional: { label: 'Positional', description: 'Most of it went in quiet moves with no tactical pattern', colour: 'var(--viz-ending-lost)' },
};

/** Every cause in the pie's order: deepest red first. */
export const GROUND_CAUSE_VIEWS: readonly GroundCauseView[] = GROUND_CAUSES.map((cause) => ({ cause, ...VIEW[cause] }));

export const groundCauseView = (cause: GroundCause): GroundCauseView => ({ cause, ...VIEW[cause] });
